module.exports = __webpack_public_path__ + "img/dia_de_tiradentes.b7be9136.svg";